import React from 'react'
import styles from './style.module.scss'
import Timeline from './Timeline'
import rio from '../../../../assets/images/olympics/Rio.svg'
import pyeongchang from '../../../../assets/images/olympics/Pyeongchang.svg'
import tokyo from '../../../../assets/images/olympics/Tokyo.svg'
import beijing from '../../../../assets/images/olympics/Beijing.svg'
import paris from '../../../../assets/images/olympics/Paris.svg'

export const TIMELINE = [
  {
    image: rio,
    title: 'Rio de Janeiro',
    year: '2016',
    styles: {
      color: '#FFA350',
      backgroundColor: '#FFF6EE'
    },
    link: 'https://oneturf.news/olympics/know-all-about-rio-de-janeiro-olympics-2016'
  },
  {
    image: pyeongchang,
    title: 'Pyeongchang',
    year: '2018',
    styles: {
      color: '#00C6DF',
      backgroundColor: '#E0F1F8'
    },
    link: 'https://oneturf.news/olympics/all-about-pyeongchang-2018-olympics'
  },
  {
    image: tokyo,
    title: 'Tokyo',
    year: '2020',
    styles: {
      color: '#FFA350',
      backgroundColor: '#FFF6EE'
    },
    link: 'https://oneturf.news/olympics/know-all-about-tokyo-olympics-2020'
  },
  {
    image: beijing,
    title: 'Beijing',
    year: '2022',
    styles: {
      color: '#00C6DF',
      backgroundColor: '#E0F1F8'
    },
    link: 'https://www.oneturf.news/olympics/all-you-need-to-know-about-beijing-2022-olympic-games-1757'
  },
  {
    image: paris,
    title: 'Paris',
    year: '2024',
    styles: {
      color: '#FFA350',
      backgroundColor: '#FFF6EE'
    },
    link: 'https://www.oneturf.news/olympics/all-you-need-to-know-about-paris-2024-olympic-games'
  }
]

const OlympicTimeline = () => {
  return (
    <div className={styles.timelineBg}>
      <div className="widget-title  d-flex justify-content-between align-items-center">
        <h3 className="small-head d-flex align-items-center  mb-0">
          <span>Olympics Timeline</span>
        </h3>
      </div>
      <div className={`${styles.olympictimeline}`}>
        <Timeline timeline={TIMELINE} />
      </div>
    </div>
  )
}

export default OlympicTimeline
